import filters from '../store';

/**
 * @param {string} filterKey
 */
export default function resetFilter(filterKey) {
	const arrayFilters = [
		'amenities',
		'building_type',
		'business_type',
		'city',
		'district',
		'interior_standard',
		'market',
		'price_change',
		'subdistrict'
	];
	const minmaxFilters = [
		'area',
		'build_year',
		'building_floors_num',
		'distance_to_subway',
		'floor_num',
		'inserted_at',
		'plot_area',
		'price',
		'rooms_num',
		'unit_price'
	];
	const numberFilters = ['lat', 'lon', 'max_transport_time', 'radius'];
	const stringFilters = ['description', 'destination', 'offer_type'];

	if (arrayFilters.some((x) => x === filterKey)) {
		filters.update((store) => ({ ...store, [filterKey]: [] }));
	} else if (minmaxFilters.some((x) => x === filterKey)) {
		filters.update((store) => ({ ...store, [filterKey]: { min: null, max: null } }));
	} else if (numberFilters.some((x) => x === filterKey)) {
		filters.update((store) => ({ ...store, [filterKey]: null }));
	} else if (stringFilters.some((x) => x === filterKey)) {
		filters.update((store) => ({ ...store, [filterKey]: null }));
	} else if (filterKey === 'offers_since') {
		filters.update((store) => ({ ...store, offers_since: 'all-time' }));
	} else if (filterKey === 'sort_by') {
		filters.update((store) => ({ ...store, sort_by: 'accuracy' }));
	}
}
